import { Typography, Input } from 'antd';
import { Check, Copy } from 'react-feather';

const { Paragraph } = Typography;
const { TextArea } = Input;

const CodeWrapper = ({ text, rows = 2 }) => {
  return (
    <div className="code-wrapper">
      <TextArea rows={rows} value={text} />
      <Paragraph
        copyable={{
          icon: [
            <div className="copy-wrapper">
              <Copy size={16} />
            </div>,
            <div className="copy-wrapper">
              <Check color="#7A4BFF" size={16} />
            </div>,
          ],
          text,
        }}
      />
    </div>
  );
};

export default CodeWrapper;
